import { Button, Grid, Typography } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useForm } from '../../../../hooks/useForm';
import moment from 'moment';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import Buscador from '../../../../actions/ui/Buscador';
import { useDispatch } from 'react-redux';
import { NuevoProblemaOdontologico } from '../../../../actions/hce/hceActions';

const today = new Date();
const stateInitial = {
  fecha: today,
  idPractica: 1,
};

export const ModalAltaPractica = (props) => {
  const [formValues, , , setearValor] = useForm(stateInitial);
  const dispatch = useDispatch();
  const [value, setValue] = useState(null);
  const { fecha } = formValues;
  const { nroDiente, hce, disabled } = props;


  const onSubmit = () => {
    let fechaModif =
      formValues.fecha instanceof Date
        ? `${formValues.fecha.toISOString()}`
        : '';
    const data = {
      idAfiliado: hce.idAfiliado,
      idAfiliadoExterno: hce.idAfiliadoExterno,
      nroPieza: nroDiente,
      codNom: value.cod_Nom,
      problema: value.des_Nom,
      idEfectorRed: hce.idEfector,
      fechaCarga: fechaModif,
    };
    dispatch(NuevoProblemaOdontologico(data));
    props.cerrarModal();
  };

  return (
    <>
      <ValidatorForm onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography
              component="h2"
              variant="h6"
              style={{
                fontSize: '1.5rem',
                textAlign: 'center',
                backgroundColor: '#68389F',
                color: 'white',
              }}
            >
              Alta nueva practica
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography
              style={{
                fontSize: '1.1rem',
                fontStyle: 'italic',
                marginTop: '0.5rem',
                marginRight: '1rem',
              }}
            >
              Pieza nro: {nroDiente}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Buscador
              value={value}
              variant="outlined"
              setValue={(val) => setValue(val)}
              label="NOMBRE NOMENCLADOR"
              noOptionText={'No se encuentra codigo/nombre'}
              endpoint={(nombreNomenclador) =>
                `HCE/Buscador/traerNomencladorOdontologico/${nombreNomenclador}`
              }
              getOptionLabel={(option) =>
                `${option.cod_Nom} ${option.des_Nom} `
              }
              renderOption={(option) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span
                    style={{ color: 'green' }}
                  >{` ${option.cod_Nom} ${option.des_Nom}`}</span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  ></span>
                </div>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                label="Fecha"
                format="dd/MM/yyyy"
                // required={true}
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={moment(fecha).isValid() ? moment(fecha) : null}
                onChange={(date) => {
                  setearValor('fecha', date);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <div
          style={{
            margin: '1rem 0',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
          }}
        >
          {!disabled &&
            <Button
              disabled={disabled}
              variant="contained"
              color="primary"
              onClick={props.cerrarModal}
            >
              Cancelar
            </Button>
          }
          {!disabled &&
            <Button
              type="submit"
              variant="contained"
              disabled={props.disabled}
              color="primary"
            >
              Guardar
            </Button>
          }
        </div>
      </ValidatorForm>
    </>
  );
};
